module.exports = __webpack_public_path__ + "pc/img/main-work-img-05.9c844a41.png";